import { Collection, } from "@bluelibs/x-ui";
import { Report } from "@root/api.types";
import { UsersCollection } from "@bundles/UIAppBundle/collections";
export class ReportsCollection extends Collection {
    getName() {
        return "Reports";
    }
    getInputs() {
        return {
            insert: "ReportInsertInput!",
            update: "ReportUpdateInput!",
        };
    }
    // Return here the relations with other configs
    getLinks() {
        return [
            {
                collection: () => UsersCollection,
                name: "createdBy",
                field: "createdById",
            },
            {
                collection: () => UsersCollection,
                name: "updatedBy",
                field: "updatedById",
            },
        ];
    }
    // Return here how you want to transform certain fields
    getTransformMap() {
        return {
            createdAt: (v) => (v && new Date(v) ? new Date(v) : v),
            updatedAt: (v) => (v && new Date(v) ? new Date(v) : v),
        };
    }
}
